import { render, staticRenderFns } from "./StackLabelsPage.vue?vue&type=template&id=0859db1e&scoped=true"
import script from "./StackLabelsPage.vue?vue&type=script&lang=js"
export * from "./StackLabelsPage.vue?vue&type=script&lang=js"
import style0 from "./StackLabelsPage.vue?vue&type=style&index=0&id=0859db1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0859db1e",
  null
  
)

export default component.exports